// extracted by mini-css-extract-plugin
export default {"background":"Deeplink_background__DW62d"};